module.exports = __webpack_public_path__ + "static/media/frog.0fd8787c.svg";